import { applyMiddleware, combineReducers, createStore as createStore_ } from 'redux';
import thunk from 'redux-thunk';
import oyo360Middleware from '../../../common/middlewares/oyo360Middleware';
import TranslationsReducer from '../../../common/reducers/TranslationsReducer';
import PopupReducer from '../../../common/reducers/PopupReducer';
import UploadToServerReducer from '../../../common/reducers/UploadToServerReducer';
import DashboardReducer from './reducers/Dashboard';
import loginReducer from './reducers/loginReducer';
import propertyInfoReducer from './reducers/propertyInfoReducer';
import addImagesReducer from './reducers/addImagesReducer';
import userLeadsReducer from './reducers/userLeadsReducer';
import kycReducer from './reducers/kycReducer';
import globalInfoReducer from './reducers/globalInfoReducer';

const MainReducer = combineReducers({
  dashboard: DashboardReducer,
  translationsReducer: TranslationsReducer,
  popupReducer: PopupReducer,
  loginReducer: loginReducer,
  propertyInfoReducer: propertyInfoReducer,
  addImagesReducer: addImagesReducer,
  kycReducer: kycReducer,
  userLeads: userLeadsReducer,
  global: globalInfoReducer,
  UploadToServerReducer: UploadToServerReducer
});

export const createStore = initialState =>
  createStore_(MainReducer, initialState, applyMiddleware(thunk, oyo360Middleware));

